/* Science Fitness theme — small vanilla-JS interactions (no framework). */
(function () {
  "use strict";

  /* ---- Scroll reveal (replaces Framer Motion fade-rise) ---- */
  var reveals = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -80px 0px", threshold: 0.05 }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* ---- Header scroll state (transparent -> blurred) ---- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.querySelector("[data-drawer]");
  var backdrop = document.querySelector("[data-drawer-backdrop]");
  var openBtn = document.querySelector("[data-drawer-toggle]");
  var closeEls = document.querySelectorAll("[data-drawer-close]");

  var subnav = document.querySelector("[data-drawer-subnav]");
  var subnavOpenBtn = document.querySelector("[data-subnav-open]");

  function setSubnav(open) {
    if (!subnav) return;
    subnav.classList.toggle("is-open", open);
    if (subnavOpenBtn) subnavOpenBtn.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    if (backdrop) backdrop.classList.toggle("is-open", open);
    if (openBtn) openBtn.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
    if (!open) setSubnav(false); // closing the drawer resets the Shop panel
  }

  if (subnavOpenBtn) subnavOpenBtn.addEventListener("click", function () { setSubnav(true); });
  document.querySelectorAll("[data-subnav-back]").forEach(function (el) {
    el.addEventListener("click", function () { setSubnav(false); });
  });

  if (openBtn) openBtn.addEventListener("click", function () { setDrawer(true); });
  if (backdrop) backdrop.addEventListener("click", function () { setDrawer(false); });
  closeEls.forEach(function (el) {
    el.addEventListener("click", function () { setDrawer(false); });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setDrawer(false);
  });

  /* ---- Fly-out cart ----
     The cart-drawer section re-renders via the Section Rendering API after
     every mutation; only [data-cart-region]'s contents are swapped, so the
     aside/backdrop persist and stay open. All events are delegated, so the
     fresh markup needs no re-binding. No-JS: bag icon links to /cart and
     product forms post natively. */
  var cartDrawerEl = document.querySelector("[data-cart-drawer]");
  var cartBackdropEl = document.querySelector("[data-cart-backdrop]");

  function setCart(open) {
    if (!cartDrawerEl) return;
    cartDrawerEl.classList.toggle("is-open", open);
    if (cartBackdropEl) cartBackdropEl.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }

  function syncCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function refreshCartDrawer(thenOpen) {
    return fetch("/?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
        var fresh = doc.querySelector("[data-cart-region]");
        var current = document.querySelector("[data-cart-region]");
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        syncCartCount();
        if (thenOpen) setCart(true);
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCartDrawer(false); })
      .catch(function () { window.location.href = "/cart"; });
  }

  if (cartDrawerEl) {
    document.addEventListener("click", function (e) {
      var openEl = e.target.closest("[data-cart-open]");
      if (openEl) { e.preventDefault(); refreshCartDrawer(true); return; }
      if (e.target.closest("[data-cart-close]")) { setCart(false); return; }
      if (e.target === cartBackdropEl) { setCart(false); return; }
      var minus = e.target.closest("[data-cart-qty-minus]");
      if (minus) { changeLine(parseInt(minus.dataset.line, 10), Math.max(0, parseInt(minus.dataset.qty, 10) - 1)); return; }
      var plus = e.target.closest("[data-cart-qty-plus]");
      if (plus) { changeLine(parseInt(plus.dataset.line, 10), parseInt(plus.dataset.qty, 10) + 1); return; }
      var rm = e.target.closest("[data-cart-remove]");
      if (rm) { changeLine(parseInt(rm.dataset.line, 10), 0); return; }
    });

    /* AJAX add-to-cart: any product form posts via cart/add.js and opens the
       drawer; on failure fall back to the native full-page submit */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf("/cart/add") === -1) return;
      e.preventDefault();
      fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () { refreshCartDrawer(true); })
        .catch(function () { form.submit(); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setCart(false);
    });
  }

  /* ---- Referral popup (Refer & Win) ----
     Progressive enhancement: the trigger is a real link to the contact page,
     so it still works without JS. Shopify's contact form posts and reloads
     with ?contact_posted=true, so the modal reopens to show the confirmation. */
  var referModal = document.querySelector("[data-refer-modal]");
  var referBackdrop = document.querySelector("[data-refer-backdrop]");
  if (referModal) {
    var lastFocus = null;
    var setRefer = function (open) {
      referModal.classList.toggle("is-open", open);
      if (referBackdrop) referBackdrop.classList.toggle("is-open", open);
      document.body.style.overflow = open ? "hidden" : "";
      if (open) {
        var first = referModal.querySelector("input, textarea, button");
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    };

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-refer-open]");
      if (trigger) {
        e.preventDefault();
        lastFocus = trigger;
        setRefer(true);
        return;
      }
      if (e.target.closest("[data-refer-close]") || e.target === referBackdrop) {
        setRefer(false);
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && referModal.classList.contains("is-open")) setRefer(false);
    });

    // reopen after a submit so the success (or error) message is actually seen
    if (referModal.querySelector("[data-refer-posted], .refer-posted") ||
        window.location.search.indexOf("contact_posted=true") !== -1) {
      setRefer(true);
    }
  }

  /* ---- Footer accordions (mobile only; md+ stays open via CSS) ---- */
  document.querySelectorAll("[data-accordion]").forEach(function (acc) {
    var toggle = acc.querySelector("[data-accordion-toggle]");
    var panel = acc.querySelector("[data-accordion-panel]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      if (window.innerWidth >= 768) return;
      var open = panel.classList.contains("hidden");
      panel.classList.toggle("hidden", !open);
      panel.classList.toggle("flex", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      var chev = toggle.querySelector("svg");
      if (chev) chev.classList.toggle("rotate-180", open);
    });
  });
})();
